<template>
  <v-container fluid>
    <div class="logo-section">
      <div class="iAnnotate-logo" />
      <span>{{ appTitle }}</span>
    </div>
    <v-divider />
    <v-list shaped>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="accent">
            <v-img v-if="userAvatar" src="userAvatar" :alt="userInitials"></v-img>
            <span v-else class="white--text">{{ userInitials }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content v-if="!userName && !userCompany">
          <v-skeleton-loader type="list-item-two-line"/>
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{userName}}</v-list-item-title>
          <v-list-item-subtitle>{{userCompany}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>
      <br />
      <v-list-item-group
        v-for="(menuItem, index) of menuItems"
        :key="index"
      >
        <v-list-item
          v-if="!menuItem.group"
          link
          :to="menuItem.routerPath"
          :disabled="menuItem.disabled"
        >
          <v-list-item-title v-text="menuItem.title"></v-list-item-title>
        </v-list-item>

        <v-list-group
          v-else
          color="default"
          :value="openedProfileSubmenu"
        >
          <template v-slot:activator>
            <v-list-item-title v-text="menuItem.title" />
          </template>
          <v-list-item
            v-for="(subMenuItem, subMenuIndex) of menuItem.group"
            :key="subMenuIndex"
            :to="subMenuItem.routerPath"
            :disabled="subMenuItem.disabled"
            class="subItemLeftPadding"
          >
            <v-list-item-title v-text="subMenuItem.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-item-group>
    </v-list>
    <span class="version_text">{{version}}</span>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "Drawer",
  props: ['appTitle'],

  data() {
    return {
      openedProfileSubmenu: null,
      menuItems: [
        {title: 'Profile', disabled: false, group: [
            // {title: 'Change password', routerPath: '/profile/change_password', disabled: false},
            // {title: 'Forgot password?', routerPath: '/profile/change_password', disabled: true},
            // {title: 'Team', routerPath: '/team', disabled: true},
            {title: 'Log out', routerPath: '/profile/logout', disabled: false},
          ]},
        {title: 'Company Information', routerPath: '/company', disabled: false},
        {title: 'iAnnotate Configuration', routerPath: '/iAnnotate_configuration', disabled: false},
        {title: 'License Key', routerPath: '/license', disabled: false},
        {title: 'Deployment Guide', routerPath: '/deployment_guide_pdf', disabled: false},
        {title:'Support',routerPath: '/support',disabled: false},
      ],
    }
  },

  computed: {
    ...mapState(['profile', 'version']),
    userAvatar() {
      return this.profile ? this.profile.avatar : null
    },
    userInitials() {
      if (!this.profile) return ''
      const {username = '', useremail = ''} = this.profile
      return username.slice(0, 2) || useremail.split('@')[0].slice(0, 2)
    },
    userCompany() {
      return this.profile ? this.profile.company : ''
    },
    userName() {
      if (!this.profile) return ''
      const {username = '', useremail = ''} = this.profile
      return username || useremail.split('@')[0]
    }
  },

  methods: {
    ...mapActions(['logOut']),
  },

  watch: {
    ["$route.path"]() {
      this.openedProfileSubmenu = /^\/profile/i.test(this.$route.path)
    }
  },
  mounted() {
    this.openedProfileSubmenu = /^\/profile/i.test(this.$route.path)
  },
}
</script>

<style scoped>
.logo-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.logo-section span {
  text-align: right;
}

.iAnnotate-logo {
  background: center no-repeat url("../assets/images/IAnnotateLogoIcon.png");
  background-size: contain;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  margin: 5px;
}

.version_text {
  color: gray;
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.subItemLeftPadding {
  padding-left: 50px;
}
</style>